import { useMemo } from 'react';
import { MOBILE_MONEY_KYIVSTAR_SERVICE_ID } from '../../constants';
import { useGetUsedSIDList } from '../useGetUsedSIDList';
import { usePSDescriptions } from '../usePSDescriptions';

export const useUserPaymentMethodsHistory = () => {
  const list = useGetUsedSIDList();
  const psDescriptionList = usePSDescriptions();

  return useMemo(
    () =>
      list
        .filter((serviceId) => serviceId !== MOBILE_MONEY_KYIVSTAR_SERVICE_ID)
        .map((serviceId) => {
          const label = psDescriptionList[serviceId]?.name || '';

          return {
            value: String(serviceId),
            label
          };
        }),
    [list, psDescriptionList]
  );
};
